module.exports = __webpack_public_path__ + "img/tree-07-b-leaves.eea8b2e2.png";